export default __webpack_public_path__ + "static/media/l.2f01c560.svg";